import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import {setPreference} from '../../../ViewDesigns/helpers/preferencesHelper';
import {FIELD_NAMES} from '../consts';
import * as Colors from 'material-ui/styles/colors';
import TemplateSelectPopover from '../../TemplateSelectPopover';
import {findDOMNode} from 'react-dom';
import DropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import AbstractListerField from './AbstractListerField';
import {getResizeUrl, getImageDataUrlFromPath} from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import TooltipWrapper from 'shared/components/TooltipWrapper';
import {eyeOff} from 'shared/icons';
import {updateSnackbarProps} from 'MyAccount/ViewDesigns/redux/modules/ebayListing';
import {updateDefaultTemplate} from 'MyAccount/ViewDesigns/redux/modules/templates';
import {connect} from 'react-redux';

@connect(
  false,
  {updateSnackbarProps, updateDefaultTemplate}
)
export default class ListerTemplateSelector extends AbstractListerField {
  state = {templateSelectPopoverOpen: false, snackbarOpen: false};

  renderPreview() {
    const {value, id} = this.props;
    const text = value[FIELD_NAMES.TEMPLATE_PREVIEW_URL] ? '' : 'No preview available';
    const backgroundData = this.getBackgroundData(eyeOff);
    return (
      <div id={`${id}-preview`} style={{minWidth: 240, minHeight: 240, ...backgroundData}}>
        <div style={{position: 'relative', top: '75%', left: '20%', color: Colors.grey400}}>{text}</div>
      </div>
    );
  }

  getBackgroundData(path) {
    const {value} = this.props;
    let backgroundImage;
    let backgroundSize;
    let backgroundPosition;
    if (value[FIELD_NAMES.TEMPLATE_PREVIEW_URL]) {
      backgroundImage = 'url(' + getResizeUrl(value[FIELD_NAMES.TEMPLATE_PREVIEW_URL], {width: 240}) + ')';
      backgroundSize = 'cover';
      backgroundPosition = 'center top';
    } else {
      backgroundImage = `url('${getImageDataUrlFromPath(path, Colors.grey300)}')`;
      backgroundSize = '150px';
      backgroundPosition = '50% 30%';
    }
    return {
      backgroundImage,
      backgroundSize,
      backgroundPosition,
      backgroundColor: Colors.grey200,
      backgroundRepeat: 'no-repeat',
    };
  }

  renderHeader() {
    const {value, id} = this.props;
    return (
      <div id={`${id}-header`} style={{backgroundColor: Colors.grey700, height: '33%'}}>
        <div style={{color: Colors.grey400, padding: 15, fontSize: 12}}>Current Template</div>
        <div id={`${id}-selected-template-name`} style={{color: Colors.white, marginLeft: 15}}>
          {value[FIELD_NAMES.TEMPLATE_NAME] ? value[FIELD_NAMES.TEMPLATE_NAME] : "Not CrazyLister's design"}
        </div>
      </div>
    );
  }

  openTemplateSelectPanel = () => {
    this.setState({templateSelectPopoverOpen: true});
  };

  handleSelect = (templateId, {name, previewUrl}) => {
    const {onChange} = this.props;
    this.setState({templateSelectPopoverOpen: false});
    onChange({
      [FIELD_NAMES.TEMPLATE_ID]: templateId,
      [FIELD_NAMES.TEMPLATE_NAME]: name,
      [FIELD_NAMES.TEMPLATE_PREVIEW_URL]: previewUrl,
    });
  };

  handleSetDefault = () => {
    const {value, updateSnackbarProps, updateDefaultTemplate} = this.props;
    setPreference('DEFAULT_TEMPLATE_ID', value[FIELD_NAMES.TEMPLATE_ID]).then(
      response => {
        if (response.success) {
          updateDefaultTemplate(value);
          updateSnackbarProps({
            open: true,
            message: 'Template ' + value[FIELD_NAMES.TEMPLATE_NAME] + ' is set as default',
          });
        }
      },
      () => {}
    );
  };

  renderConfiguration() {
    const {value, id} = this.props;
    const {templateSelectPopoverOpen} = this.state;
    const idSuffix = value[FIELD_NAMES.TEMPLATE_ID] ? 'change-template' : 'pick-template';
    return (
      <div style={{height: '67%', backgroundColor: Colors.white, display: 'flex', alignItems: 'flex-end'}}>
        <RaisedButton
          id={`${id}-${idSuffix}`}
          style={{margin: 20}}
          label={value[FIELD_NAMES.TEMPLATE_ID] ? 'change template' : 'pick a template'}
          labelPosition="before"
          ref={ref => {
            if (ref) this.templateSelectButton = findDOMNode(ref);
          }}
          icon={<DropDownIcon />}
          onClick={this.openTemplateSelectPanel}
        />
        {value[FIELD_NAMES.TEMPLATE_ID] && (
          <TooltipWrapper
            tooltip={
              value[FIELD_NAMES.TEMPLATE_NAME] === 'Custom Design'
                ? 'You can not set Custom Design as default'
                : 'Make this template default for new listings'
            }
          >
            <FlatButton
              id={`${id}-set-default`}
              style={{margin: 20}}
              label="set as default"
              disabled={value[FIELD_NAMES.TEMPLATE_NAME] === 'Custom Design'}
              onClick={this.handleSetDefault}
            />
          </TooltipWrapper>
        )}
        <TemplateSelectPopover
          onSelect={this.handleSelect}
          open={templateSelectPopoverOpen}
          onClose={() => this.setState({templateSelectPopoverOpen: false})}
          anchorEl={this.templateSelectButton}
        />
      </div>
    );
  }

  render() {
    return (
      <div style={{display: 'flex', width: '100%', marginBottom: 20}}>
        {this.renderPreview()}
        <div style={{width: '80%'}}>
          {this.renderHeader()}
          {this.renderConfiguration()}
        </div>
      </div>
    );
  }
}
